module.exports = __webpack_public_path__ + "img/login_background.bb6126f3.jpg";